import React from 'react';
import { Container, Title, Paper, Text } from '@mantine/core';

export const RecoveryCodesPage: React.FC = () => {
  return (
    <Container size="xl">
      <Paper withBorder p="xl">
        <Title order={2} mb="md">Recovery Codes</Title>
        <Text c="dimmed">View and manage your account recovery codes.</Text>
      </Paper>
    </Container>
  );
};